import { Assessment, FilteredInfo } from '../../interfaces';
import {
  FilterInputWrapper,
  FilterResetButton,
  FilterSearchButton,
  FilterWrapper,
  iconProps,
} from './style';
import { Icon, Input } from 'antd';
import React, { FC, ReactText } from 'react';
import { ColumnProps, FilterDropdownProps } from 'antd/es/table';

export const getColumnSearchProps = (
  dataIndex: string,
  filteredInfo: FilteredInfo,
  setFilteredInfo: (value: ((prevState: FilteredInfo) => FilteredInfo) | FilteredInfo) => void,
  searchInput: React.RefObject<Input>
): ColumnProps<Assessment> => {
  const handleSearch = (
    selectedKeys: ReactText[],
    confirm: () => void,
    dataIndex: string
  ): void => {
    setFilteredInfo(prevState => ({ ...prevState, [dataIndex]: selectedKeys }));
    confirm();
  };

  const handleReset = (
    selectedKeys: ReactText[],
    clearFilters: () => void,
    dataIndex: string
  ): void => {
    setFilteredInfo(prevState => ({ ...prevState, [dataIndex]: [] }));
    clearFilters();
  };

  const getFilterDropdown: FC<FilterDropdownProps> = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterWrapper>
      <FilterInputWrapper>
        <Input
          ref={searchInput}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        />
      </FilterInputWrapper>
      <FilterSearchButton
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
        size="small"
      >
        Search
      </FilterSearchButton>
      <FilterResetButton
        onClick={() => handleReset(selectedKeys, clearFilters, dataIndex)}
        size="small"
      >
        Reset
      </FilterResetButton>
    </FilterWrapper>
  );

  const getFilterIcon = (filtered: boolean) => <Icon {...iconProps(filtered)} />;

  const getOnFilter = (value: string, record: Assessment) => {
    return (
      record[dataIndex] &&
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
    );
  };

  const getOnFilterDropdownVisibleChange = (visible: boolean) => {
    if (visible) {
      setTimeout(() => searchInput.current.focus());
    }
  };

  return {
    filteredValue: filteredInfo[dataIndex] || null,
    filterDropdown: getFilterDropdown,
    filterIcon: getFilterIcon,
    onFilter: getOnFilter,
    onFilterDropdownVisibleChange: getOnFilterDropdownVisibleChange,
  };
};
